export default __webpack_public_path__ + "static/media/telegram.a6324639.svg";